// Story 175 (D-4, RN48-RN50, contract §5) -- links from the Planner to the MIC-4293 dashboards. The base
// URL is an installation setting read from `useFrontEndConfig()`; blank or missing means "no link".
// The parameters keep the frozen H153 §5 names, empty ones are left out, and they are appended with
// `?` or `&` depending on whether the base URL already carries a query.

export const isDashboardUrlConfigured = (baseUrl) => typeof baseUrl === 'string' && baseUrl.trim() !== ''

export const buildDashboardHref = (baseUrl, params = {}) => {
  if (!isDashboardUrlConfigured(baseUrl)) {
    return ''
  }
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== null && value !== undefined && value !== '')
  ).toString()
  if (query === '') {
    return baseUrl
  }
  return baseUrl + (baseUrl.includes('?') ? '&' : '?') + query
}

// Contract §5, origin "machine detail": always weekly and by planned date, like the detail itself.
export const machineDashboardParams = ({ planificationId, plannerFilters = {}, deviceId }) => ({
  planificationId,
  fabricationOrderId: plannerFilters.fabricationOrderId,
  partReferenceId: plannerFilters.partReferenceId,
  orderId: plannerFilters.orderId,
  clientId: plannerFilters.clientId,
  deviceId,
  grouping: 'WEEK',
  reading: 'PLANNED_DATE',
  timeZone: plannerFilters.timeZone
})

// Contract §5, origin "details table": the plan and the global filters only. The table's status filter, its
// "Asset" selector and the selected fabrication order never travel (RN49: not in the frozen list).
export const deliveryDashboardParams = ({ planificationId, plannerFilters = {} }) => ({
  planificationId,
  fabricationOrderId: plannerFilters.fabricationOrderId,
  partReferenceId: plannerFilters.partReferenceId,
  orderId: plannerFilters.orderId,
  clientId: plannerFilters.clientId,
  timeZone: plannerFilters.timeZone
})
